import { readFile } from 'node:fs/promises';

export interface FileSnapshot {
  absPath: string;
  displayPath: string;
  originalContent: string | null;
}

/**
 * Original file contents captured the instant permission is granted,
 * BEFORE any tool mutates the workspace. Consumed afterwards by the
 * diff renderer to draw before/after unified diffs.
 */
const originals = new Map<string, { content: string; displayPath: string }>();

export async function snapshotOriginal(absPath: string, displayPath?: string): Promise<void> {
  if (originals.has(absPath)) return;
  let content = '';
  try {
    content = await readFile(absPath, 'utf8');
  } catch {
    // File does not exist yet — an empty original produces a pure-add diff.
  }
  originals.set(absPath, { content, displayPath: displayPath ?? absPath });
}

/** Drain all snapshots captured during this turn (and clear them). */
export function takeSnapshots(): FileSnapshot[] {
  const entries: FileSnapshot[] = [];
  for (const [absPath, snapshot] of originals) {
    entries.push({ absPath, displayPath: snapshot.displayPath, originalContent: snapshot.content });
  }
  originals.clear();
  return entries;
}

/** Test/inspection helper. */
export function snapshotCount(): number {
  return originals.size;
}
